<p-toast key="{{ messageKey }}"></p-toast>

<app-hero *transloco="let t" [title]="t('page_approval_title')"> </app-hero>

<div class="px-8" *transloco="let t">
  <div class="-mt-8 bg-white shadow-md">
    <div class="p-8">
      @if (requestEntry) {
        <div>
          <h3 class="mb-2 text-xl">{{ requestEntry.engagementName }}</h3>
          <hr class="separator" />
          <div class="grid grid-cols-2 gap-4 small-form">
            <div>
              <strong>{{ t("jobcode") }}</strong>
            </div>
            <div>{{ requestEntry.jobCode }}</div>
            <div>
              <strong>{{ t("name") }}</strong>
            </div>
            <div>{{ requestEntry.requestorName }}</div>
            <div>
              <strong>{{ t("email") }}</strong>
            </div>
            <div>{{ requestEntry.requestorEmail }}</div>
            <div>
              <strong>{{ t("request_date") }}</strong>
            </div>
            <div>
              <render-value
                data="{{ requestEntry.requestDate }}"
                template="date"
              ></render-value>
            </div>
            <div>
              <strong>{{ t("approval_date") }}</strong>
            </div>
            <div>
              <render-value
                data="{{ requestEntry.approvalDate }}"
                template="date"
              ></render-value>
            </div>
            <div>
              <strong>{{ t("status") }}</strong>
            </div>
            <div>{{ requestEntry.status }}</div>
          </div>
          @if (
            !(
            requestEntry.status == 'Approved' ||
            requestEntry.status == 'Rejected' ||
            requestEntry.status == 'Revoked'
            )
            ) {
            <div
              class="mt-6"
              >
              <p-button
                [label]="t('accept')"
                (onClick)="approve(requestEntry.accessRequestId, true)"
                styleClass="p-button-success mr-2"
                />
              <p-button
                [label]="t('reject')"
                (onClick)="approve(requestEntry.accessRequestId, false)"
                styleClass="p-button-danger"
                />
            </div>
          }
        </div>
      }
      @if (error) {
        <div>
          <h3 class="mb-2 text-xl">{{ t("error") }}</h3>
        </div>
      }
    </div>
  </div>
</div>
